import type { TablePaginationConfig } from "antd";

interface PaginationPresetArgs {
	page: number;
	limit: number;
	total?: number;
	onChange: (page: number, pageSize: number) => void;
	/** Allow changing page size (default true). */
	sizeChanger?: boolean;
}

/**
 * Standard table pagination config. Centralizes the `showSizeChanger` / `showTotal`
 * settings that currently differ per module (some true, some false, some default).
 */
export function tablePagination({
	page,
	limit,
	total,
	onChange,
	sizeChanger = true,
}: PaginationPresetArgs): TablePaginationConfig {
	return {
		current: page,
		pageSize: limit,
		total,
		onChange,
		showSizeChanger: sizeChanger,
		pageSizeOptions: [10, 20, 50, 100],
		showTotal: (t) => `Jami: ${t}`,
	};
}
